import React, {useState} from "react";
import BACENTable from "./BACENTable/BACENTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils"
import { useTranslation } from 'react-i18next';

function BACENCard(props) {

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);
    const { t } = useTranslation()

    const {bacen} = props
    let initialExpand = bacen.flag !== "positive"
    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("qgi_bacen")}
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(bacen.flag)}
                </div>
                {bacen.data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>             
                }                    
            </div>
            {bacen.data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <BACENTable bacen_data={bacen.data}/>
                </div>
            </Collapse> 
            }     
        </div>
        );
}

export default BACENCard